import { UserOrgRoles } from "../types/user";

export const hasCompanyEventPlannerRole = (roles: UserOrgRoles) => {
  const index = roles.indexOf("companyEventPlanner");
  return index !== -1;
};
